module.exports = __webpack_public_path__ + "static/interior_right-ca61cca998f52c7dd9d5d07099424be0.png";